import { useContext, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import bgImage from "assets/images/login-icon.jpg";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoginFormContext } from "context/LoginFormContext";
import { userLogIn } from "Apis/signIn";
import { AuthRouteJson } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";

function Basic() {
  const navigate = useNavigate();
  const [visiblePassword, setVisiblePassword] = useState(false);
  const { setNotification, LogIn, AppLoader, setIsLoading } = useContext(LoginFormContext);
  const { sideNav } = colors;

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format!").required("Email is required!"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters!")
      .required("Password is required!"),
  });
  function setLoginTimestamp() {
    localStorage.setItem("loginTime", Date.now().toString());
  }
  const handleSubmit = async (values) => {
    AppLoader(true);
    let response = await userLogIn(values);
    if (response?.status === 200) {
      await LogIn(response.data.data);
      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response.data.message,
        open: true,
      });
      setLoginTimestamp();
      navigate("/dashboard");
      AppLoader(false);
    } else {
      AppLoader(false);
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: response.data.message,
        open: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });
  return (
    <MDBox
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        justifyContent: "center",
        background: `${sideNav.hover}`,
      }}
    >
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          width: "80%",
          maxWidth: "1030px",
          padding: "20px",
          gap: "25px",
          background: `${sideNav.backGround}`,
          borderRadius: "8px",
          margin: "0 auto",
          justifyContent: "center",
          "@media (max-width:1020px)": {
            flexDirection: "column",
          },
          "@media (max-width:767px)": {
            width: "90%",
          },
        }}
      >
        <MDBox
          sx={{
            width: "auto",
            height: "460px",
            "@media (max-width: 1020px)": { width: "auto", height: "170px" },
            // "@media (max-width:767px)": { width: "auto", height: "200px" },
          }}
        >
          <img
            src={bgImage}
            width={100}
            height={100}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </MDBox>
        <Card
          sx={{
            gap: "10px",
            width: "52%",
            background: "transparent",
            boxShadow: "none",
            "@media (max-width:1020px)": {
              width: "100%",
            },
          }}
        >
          <MDBox textAlign="center">
            <MDTypography variant="h4" fontWeight="medium" color="#334155">
              Sign in
            </MDTypography>
          </MDBox>
          <MDBox p={{ xl: 2.25 }}>
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
              <MDBox mb={2}>
                <MDInput
                  variant="standard"
                  type="email"
                  label="Email"
                  fullWidth
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <MDBox
                    component="p"
                    sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
                  >
                    {formik.errors.email}
                  </MDBox>
                )}
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  variant="standard"
                  type={!visiblePassword ? "password" : "text"}
                  name="password"
                  label="Password"
                  fullWidth
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setVisiblePassword(!visiblePassword)}
                          edge="end"
                          size="large"
                        >
                          {!visiblePassword ? (
                            <VisibilityOff sx={{ width: "25px", height: "25px" }} />
                          ) : (
                            <Visibility sx={{ width: "25px", height: "25px" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.password && formik.errors.password && (
                  <MDBox
                    component="p"
                    sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
                  >
                    {formik.errors.password}
                  </MDBox>
                )}
              </MDBox>
              <MDBox sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <MDTypography
                  component={Link}
                  to={AuthRouteJson.forgotpassword}
                  fontWeight="regular"
                  color="text"
                  sx={{ textAlign: "right", fontSize: "14px", cursor: "pointer" }}
                >
                  Forgot Password?
                </MDTypography>
              </MDBox>

              <MDBox mt={4} mb={1}>
                <SubmitButton type="submit" btnText={"sign  in"} width="100%" />
              </MDBox>
              {/* <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient 
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox> */}
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </MDBox>
  );
}

export default Basic;
